import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export type ModalConfirmDeleteProps = OpenControls & {
  onClose: () => void;
  onDelete: () => void;
  selectedAttachments: boolean[];
};

const ModalConfirmDelete = ({
  isOpen,
  handleClose,
  onDelete,
  selectedAttachments,
  onClose,
}: ModalConfirmDeleteProps) => {
  const renderFooter = () => (
    <div>
      <Button
        label="No"
        icon="pi pi-times"
        onClick={() => {
          handleClose();
          onClose();
        }}
        className="button-text"
      />
      <Button label="Yes" icon="pi pi-check" onClick={onDelete} autoFocus />
    </div>
  );

  return (
    <Dialog
      header="Remove Attachments"
      visible={isOpen}
      footer={renderFooter()}
      onHide={handleClose}
      style={{ maxWidth: '500px', minWidth: '500px' }}
    >
      <div className="flex confirmation-content">
        <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
        <span>Are you sure to remove these {selectedAttachments.filter((sf) => sf === true).length} attachments? They will not be removed until the form is submitted.</span>
      </div>
    </Dialog>
  );
};

export default ModalConfirmDelete;
